<template>
<b-container class="question-type4">
    <b-modal id="confirm-submit-record" hide-footer centered>
        <template #modal-title>
            <h6>Xác nhận</h6>
        </template>
        <div class="d-block text-center">
            <div class="alert alert-warning" role="alert">
                <p class="mb-1">Bạn chắc chắn muốn nộp bài không?</p>
                <p class="">Khi đã nộp bài, bạn sẽ không thể chỉnh sửa câu trả lời của mình nữa.</p>
            </div>
            <!-- <div class="alert alert-warning" role="alert">
                    <p class="mb-1">Bạn chắc chắn muốn nộp bài không?</p>
                    <p class="">Khi đã nộp bài, bạn sẽ không thể chỉnh sửa câu trả lời của mình nữa.</p>
                </div> -->
            <div>
                <b-button class="mx-3" variant="secondary" block @click="$bvModal.hide('confirm-submit-record')">Hủy</b-button>
                <b-button class="mx-3" variant="primary" block @click="submitRecord">Xác nhận</b-button>
            </div>
        </div>
    </b-modal>
    <b-row v-if="step == 1">
        <div class="h3 text-center py-5" v-html="content.description"></div>
    </b-row>
    <b-row :class="{'d-none': step == 1}">
        <div class="item_quesion">
            <div class="header_question text-center">
                <h2>{{ jsonParse(questions.content).title }}</h2>
            </div>
            <div class="image-block" v-if="checkFileTypeWithFileName(jsonParse(questions.content).file) == 'image'">
                <div class='text-center w-100 mb-2'>
                    <img class="mw-100 " style="max-height: 440px" :src="jsonParse(questions.content).file"/>
                </div>
                <div v-if="!hideControl" class="d-flex flex-column justify-content-center align-items-center w-100">

                    <div v-if="!recordTrack" class="d-flex flex-column">
                        <b-button @click="startRecord" v-if="!isRecord && !introVideo" pill variant="danger" class="my-2">
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                                <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                                <line x1="12" y1="19" x2="12" y2="23"></line>
                                <line x1="8" y1="23" x2="16" y2="23"></line>
                            </svg>
                            Ghi âm câu trả lời
                        </b-button>
                        <b-button v-if="!isRecord" @click="skipQuestion" pill variant="warning" class="my-2">
                            Bỏ qua câu hỏi này
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </b-button>
                    </div>

                    <div v-if="isRecord" class="d-flex flex-column">
                        <b-button @click="stopRecord" v-if="isRecord" pill variant="warning" class="my-2">
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                                <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                                <line x1="12" y1="19" x2="12" y2="23"></line>
                                <line x1="8" y1="23" x2="16" y2="23"></line>
                            </svg>
                            Dừng ghi âm ({{ recordTime }})
                        </b-button>
                    </div>

                    <div v-if="recordTrack" class="d-flex flex-column">
                        <b-button @click="recordReplayStop" v-if="audioReplayPlaying" pill variant="secondary" class="my-2">
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                                <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                            </svg>
                            Dừng ({{ second2Minute(audioReplayDurationTime) }})
                        </b-button>
                        <b-button @click="recordReplayPlay" v-if="!audioReplayPlaying" pill variant="secondary" class="my-2">
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                                <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                            </svg>
                            Nghe lại ({{ recordTrack.duration }})
                        </b-button>
                        <b-button @click="removeAllRecord" pill variant="danger" class="my-2">
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                <polyline points="3 6 5 6 21 6"></polyline>
                                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                <line x1="10" y1="11" x2="10" y2="17"></line>
                                <line x1="14" y1="11" x2="14" y2="17"></line>
                            </svg>
                            Xóa bản ghi âm này
                        </b-button>
                        <b-button @click="submitRecordAction" pill variant="success" class="my-2">
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                <path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path>
                                <polygon points="12 15 17 21 7 21 12 15"></polygon>
                            </svg>
                            Nộp bản ghi âm này
                        </b-button>
                    </div>
                </div>
            </div>
            <div class="video-block" v-if="checkFileTypeWithFileName(jsonParse(questions.content).file) == 'video'">
                <video ref="video-play" class="mw-100" :src="jsonParse(questions.content).file" id="video-play"></video>
                <div class="video-time">
                    <span>{{ second2Minute(videoCurrentTime) }} / {{ second2Minute(videoDurationTime) }}</span>
                </div>
                <div v-if="!hideControl" class="controller-block d-flex flex-column justify-content-center align-items-center w-100">

                    <div v-if="!recordTrack" class="d-flex flex-column">
                        <b-button :disabled="videoReplayCount == 0" v-if="!isRecord" @click="videoPlay" pill variant="primary" class="my-2">
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect>
                                <line x1="7" y1="2" x2="7" y2="22"></line>
                                <line x1="17" y1="2" x2="17" y2="22"></line>
                                <line x1="2" y1="12" x2="22" y2="12"></line>
                                <line x1="2" y1="7" x2="7" y2="7"></line>
                                <line x1="2" y1="17" x2="7" y2="17"></line>
                                <line x1="17" y1="17" x2="22" y2="17"></line>
                                <line x1="17" y1="7" x2="22" y2="7"></line>
                            </svg>
                            Xem video ({{ videoReplayCount }})
                        </b-button>
                        <b-button @click="startRecord" v-if="!isRecord && !introVideo" pill variant="danger" class="my-2">
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                                <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                                <line x1="12" y1="19" x2="12" y2="23"></line>
                                <line x1="8" y1="23" x2="16" y2="23"></line>
                            </svg>
                            Ghi âm câu trả lời
                        </b-button>
                        <b-button v-if="!isRecord" @click="skipQuestion" pill variant="warning" class="my-2">
                            Bỏ qua câu hỏi này
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </b-button>
                    </div>

                    <div v-if="isRecord" class="d-flex flex-column">
                        <b-button @click="stopRecord" v-if="isRecord" pill variant="warning" class="my-2">
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                                <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                                <line x1="12" y1="19" x2="12" y2="23"></line>
                                <line x1="8" y1="23" x2="16" y2="23"></line>
                            </svg>
                            Dừng ghi âm ({{ recordTime }})
                        </b-button>
                    </div>

                    <div v-if="recordTrack" class="d-flex flex-column">
                        <b-button @click="recordReplayStop" v-if="audioReplayPlaying" pill variant="secondary" class="my-2">
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                                <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                            </svg>
                            Dừng ({{ second2Minute(audioReplayDurationTime) }})
                        </b-button>
                        <b-button @click="recordReplayPlay" v-if="!audioReplayPlaying" pill variant="secondary" class="my-2">
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                                <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                            </svg>
                            Nghe lại ({{ recordTrack.duration }})
                        </b-button>
                        <b-button @click="removeAllRecord" pill variant="danger" class="my-2">
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                <polyline points="3 6 5 6 21 6"></polyline>
                                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                <line x1="10" y1="11" x2="10" y2="17"></line>
                                <line x1="14" y1="11" x2="14" y2="17"></line>
                            </svg>
                            Xóa bản ghi âm này
                        </b-button>
                        <b-button @click="submitRecordAction" pill variant="success" class="my-2">
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                <path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path>
                                <polygon points="12 15 17 21 7 21 12 15"></polygon>
                            </svg>
                            Nộp bản ghi âm này
                        </b-button>
                    </div>

                </div>
            </div>
            <audio ref="audio-replay" src=""></audio>
        </div>
    </b-row>
    <div class="d-flex justify-content-center pt-5" v-if="step == 1">
        <b-button @click="nextQuestion" class="btn-custom" variant="success">{{ step == 1 ? 'Start' : 'Next' }}</b-button>
    </div>
</b-container>
</template>

<script>
// import AudioRecorder from '@/components/record/recorder.vue'
// import Config from '../../../config'
import Recorder from '../lib/recorder'
import EventBus from '../../libs/EventBus'

export default {
    props: {
        content: Object
    },
    components: {
        // AudioRecorder
    },
    created() {
        this.initRecord()

        if (this.content.question_index) {
            this.questionIndex = this.content.question_index
        }

        if (this.content.step) {
            this.step = this.content.step
        }

        if (this.content.video_replay) {
            this.videoReplayCount = this.content.video_replay
        }

        if (this.questionIndex == 0) {
            this.step = 1
        }

        EventBus.$on('TIME_UP', this.timeUpHandle)
    },
    mounted() {},
    methods: {
        checkFileTypeWithFileName (filename) {
            
            if (!filename ) return '';

            let file_ext = filename.split('.').pop()

            if (!file_ext) return '';

            file_ext = file_ext.toLowerCase()

            if (['acc', 'wma', 'wav', 'mp4', 'mp3', 'flac', 'm4a'].includes(file_ext)) return 'video'
            if (['jpeg', 'jpg', 'png'].includes(file_ext)) return 'image'

        },
        async timeUpHandle () {
            if (this.isRecord) {
                this.stopRecord()
                this.submitRecord()
                .then(() => {
                    this.emitEndPart()
                })
            } else {
                this.emitEndPart()
            }
        },
        emitEndPart () {
            this.$emit('end-part')
        },
        submitRecordAction() {
            this.$bvModal.show('confirm-submit-record')
        },
        submitRecord () {
            return new Promise( (resolve, reject) => {
                this.saveRecord()
                .then(() => {
                    this.$TestApp.testSave()
                    .then(() => {
                        this.$bvModal.hide('confirm-submit-record')
                        this.nextQuestion();
                        resolve(true);
                    })
                    .catch((err) => {
                        this.$bvToast.toast(err, {
                            title: `Có lỗi xảy ra !`,
                            variant: 'danger',
                            solid: true
                        })
                        reject(err)
                    } )
                })
            })
        },
        saveRecord() {
            const formData = new FormData();
            formData.append('audio', this.recordTrack.blob, `audioRecord-${new Date().getTime()}.mp3`)

            return new Promise( (resolve, reject) => {
                this.$http.post(this.upload_url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then( (response) => {
                    if (response.data.code == 1) {
                        this.$TestApp.qAnswer(this.questions.id, response.data.data.src)
                        // this.$store.commit('SET_ANSWER', {
                        //     id: this.questions.id,
                        //     value: response.data.data.src
                        // })
                        resolve(response)
                    }
                })
                .catch((err) => {
                    reject(err)
                } )
            })
        },

        recordReplayPlay() {
            const self = this;
            if (this.recordTrack) {

                this.$refs['audio-replay'].src = this.recordTrack.url
                this.$refs['audio-replay'].load()

                this.$refs['audio-replay'].addEventListener('canplay', function () {
                    self.audioReplayPlaying = true
                    self.$refs['audio-replay'].play()
                })
                this.$refs['audio-replay'].addEventListener('ended', function () {
                    self.audioReplayPlaying = false
                })
                this.$refs['audio-replay'].addEventListener('timeupdate', function (event) {
                    self.audioReplayDurationTime = event.target.currentTime
                })
            }
        },
        recordReplayStop() {
            this.$refs['audio-replay'].pause()
            this.audioReplayPlaying = false
        },
        videoPlay() {

            if (this.videoReplayCount > 0) {
                this.$refs['video-play'].play()
                this.$refs['video-play'].addEventListener('ended', this.videoEndedHandle)
                this.$refs['video-play'].addEventListener('play', this.videoPlayHandle)
                this.$refs['video-play'].addEventListener('timeupdate', this.videoTimeupdateHandle)

                this.videoReplayCount--

                this.$TestApp.setVideoPlayCouter(this.videoReplayCount)
            }
        },
        videoEndedHandle() {
            this.hideControl = false
        },
        videoTimeupdateHandle(event) {
            this.videoCurrentTime = event.target.currentTime
            this.videoDurationTime = event.target.duration
        },
        videoPlayHandle() {
            this.hideControl = true
        },
        second2Minute(seconed) {
            return `${(seconed / 60).toFixed(0) < 10 ? '0' + (seconed / 60).toFixed(0) : (seconed / 60).toFixed(0)}: ${(seconed % 60).toFixed(0) < 10 ? '0' + (seconed % 60).toFixed(0) : (seconed % 60).toFixed(0)}`
        },
        jsonParse(string) {
            try {
                return JSON.parse(string)
            } catch (error) {
                //
            }
            return {}
        },

        startRecord() {
            const self = this;

            navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;

            if (typeof navigator.getUserMedia === 'undefined') {
                navigator.mediaDevices.getUserMedia({
                    audio: true
                }).then(streamHandler => {
                    if (streamHandler.getAudioTracks().length > 0) {
                        self.recorder.start()
                    } else {
                        alert('Không tìm thấy mic')
                    }
                }).catch(errorHandler => {
                    if (errorHandler.name == 'NotAllowedError') {
                        alert('Yêu cầu truy cập mic đã bị từ chối, hãy kiểm tra và thử lại')
                    } else {
                        alert(errorHandler)
                        console.log(errorHandler)
                    }
                });
            } else {
                navigator.getUserMedia({
                    audio: true
                }, function (stream) {
                    if (stream.getAudioTracks().length > 0) {
                        self.recorder.start()
                    } else {
                        alert('Không tìm thấy mic')
                    }
                }, function (error) {
                    if (error.name == 'NotAllowedError') {
                        alert('Yêu cầu truy cập mic đã bị từ chối, hãy kiểm tra và thử lại')
                    } else {
                        alert(error)
                        console.log(error)
                    }
                });
            }
        },
        stopRecord() {
            this.recorder.stop()
        },
        removeAllRecord() {
            this.recorder.records = []
        },

        initRecord() {
            this.recorder = new Recorder({
                format: "wav",
                bitRate: 128,
                sampleRate: 44100
            })
        },

        saveTest() {

            return new Promise((resovel, reject) => {
                const self = this
                const trackid = localStorage.getItem('_speakup_track')
                self.$http.post('/test-save-v2', {
                    trackid: trackid,
                    test_data: JSON.parse(localStorage.getItem('speakupTestData')),
                })
                .then( (response) => {
                    if (response.data.code === 1) {
                        this.$bvModal.hide('confirm-submit-record')
                        this.nextQuestion();
                        resovel(response)
                    } else {
                        this.$bvToast.toast(response.data.message, {
                            title: `Có lỗi xảy ra !`,
                            variant: 'danger',
                            solid: true
                        })
                        reject(response.data.message)
                    }
                })
            })
        },

        skipQuestion() {
            this.$bvModal.msgBoxConfirm('Bạn chắc chắn muốn bỏ qua câu hỏi này ?', {
                    title: 'Xác nhận',
                    size: 'lg',
                    buttonSize: 'sm',
                    okVariant: 'primary',
                    okTitle: 'Vâng',
                    cancelTitle: 'Không',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value == true) {
                        this.nextQuestion()
                    }
                })
        },

        nextQuestion() {
            if (this.step == 1) {
                this.step = 2
                this.$TestApp.setPartStep(this.step)
                return;
            }
            if (this.questionIndex < this.content.questions.length - 1) {
                this.questionIndex++
            } else {
                //
                this.$emit('end-part')
            }

            this.removeAllRecord()
            this.videoReplayCount = 2;
            this.$TestApp.setVideoPlayCouter(this.videoReplayCount)
            this.$TestApp.setQuestionIndex(this.questionIndex)
            this.$refs['video-play'].addEventListener('canplay', this.videoReady)
        },
    },
    computed: {
        introVideo () {
            return this.questions?.settings?.intro_video || false
        },
        recordTrack() {
            return this.recorder.records[0]
        },
        isRecord() {
            return this.recorder.isRecording
        },
        recordTime() {
            return this.second2Minute(this.recorder.duration)
        },
        questions() {
            return this.content.questions[this.questionIndex]
        },
        nameFile: function () {
            return localStorage.getItem("_speakup_track") + 'ninja';
        },
    },
    watch: {},
    data() {
        return {
            array_link: [],
            upload_url: `/uploads`,
            message: '',
            mp3: '/demo/example.mp3',
            showRecorder: true,
            headers: {
                'X-Custom-Header': 'some data'
            },
            step: 1,
            questionIndex: 0,
            videoElement: null,
            hideControl: false,
            videoCurrentTime: 0,
            videoDurationTime: 0,
            videoReplayCount: 2,

            recorder: null,
            audioReplayPlaying: false,
            audioReplayDurationTime: 0
        }
    }
}
</script>

<style scoped>
.header_question h2 {
    font-size: 25px;
    font-weight: 800;
    color: #0057a7;
}

.content_question {
    /* margin-top: 15px; */
    flex-wrap: wrap;
    justify-content: space-between;
}

.item_answer {
    /* display: flex; */
    margin-bottom: 10px;
    padding: 5px 20px;
    border-radius: 15px;
    /* display: flex; */
    align-items: center;
    color: #0057a7;
    font-weight: 600;
    transition: 0.3 ease;
}

.text_answer {
    margin-left: 10px;
}

video::-webkit-media-controls {
    display: none;
}

.controller-block {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #00000070;
}

.video-block {
    position: relative;
    min-height: 400px;
}

.video-time {
    position: absolute;
    top: 10px;
    left: 10px;
    font-weight: 700;
    font-size: 20px;
    color: #fff;
    text-shadow: 1px 1px #000000bd
}
</style>

<style>
.text_answer input {
    border: 1px solid #0057a7;
    border-radius: 12px;
    margin: 0 5px;
    height: 30px;
    padding: 0 10px;
    color: #0057a7;
}

@media only screen and (max-width: 768px) {
    .header_question h2 {
        font-size: 18px;
    }

    .header_question .title_question {
        /* font-size: 17px; */
    }

    .item_answer {
        width: 100% !important;

    }
}

@media only screen and (max-width: 500px) {
    .text_answer input {
        width: 100px;
    }
}
</style>
